import * as constAction from 'root/actionConstants';
import { Map, List, fromJS } from 'immutable';

var defaultState = Map({
  lista: List(),
  penalizacionesUsuario: List(),
  showListaPenalizaciones: false,
  scrollControl: Map({
    hasMore: true,
    cantResults: 0,
    fecha: new Date(),
  }),
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.PENALIZACIONES_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload)) return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.PENALIZACIONES_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/modules/penalizaciones/reducer.js